import React, { Component } from 'react';
import '../styles/App.css';

class App extends Component {
  render() {
    return (
      <div className="app_box">
        <div className="app_content">
        </div>
        </div>
      );
    }
  }
          

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js